export default "<div class=\"container\">\r\n  <p class=\"text-muted\">Facility Management Control Unit &copy; ({{ info }})</p>\r\n</div>\r\n";